import React, { useEffect } from "react";

import { INITIAL_RESULT_LENGTH, SEARCH_INITIAL_TAKE } from "constants/search";
import useStrainsWithMenuItemAvailability from "hooks/useStrainsWithMenuItemAvailability";
import useSearch from "redux/hooks/useSearch";

import StrainCard, {
  StrainCardAccessoryTray,
  StrainCardPlaceholder,
} from "components/botanic/StrainCard";
import ButtonPlaceholder from "components/ButtonPlaceholder";
import PhenotypeCarousel from "components/PhenotypeCarousel";
import SearchViewMoreButton from "components/search/SearchViewMoreButton";

const StrainResults: React.FC = () => {
  const { strain, loading, searchCategory, searchTerm, loadMoreSearchResults } =
    useSearch();

  const isCategoryTab = searchCategory === "strain";

  useEffect(() => {
    if (isCategoryTab && strain.length === SEARCH_INITIAL_TAKE) {
      loadMoreSearchResults("strain", 7);
    }
  }, [isCategoryTab]);

  const strains = isCategoryTab
    ? strain
    : strain.slice(0, INITIAL_RESULT_LENGTH);

  const { strainsWithMenuItemAvailability } =
    useStrainsWithMenuItemAvailability(strains);

  return (
    <>
      <h2>Strains</h2>
      <p className="mb-lg">matching "{searchTerm}"</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {loading
          ? new Array(isCategoryTab ? 8 : INITIAL_RESULT_LENGTH)
              .fill(null)
              .map((_, i) => (
                <div
                  className="h-full shadow-low rounded bg-white"
                  key={`strain-card-placeholder-${i}`}
                >
                  <StrainCardPlaceholder
                    orientation={{
                      desktop: "vertical",
                      mobile: "horizontal",
                    }}
                  />
                  <div className="px-md mb-md">
                    <ButtonPlaceholder height="36" />
                  </div>
                </div>
              ))
          : strains.map((strain) => {
              const hasMenuItems = strainsWithMenuItemAvailability.find(
                (str) => str.name === strain.name,
              )?.hasMenuItems;

              return (
                <StrainCard
                  key={strain.id}
                  orientation={{ desktop: "vertical", mobile: "horizontal" }}
                  preserveHeight={{ desktop: true, mobile: false }}
                  imageSizes={[75, null, 215, null, null, 215]}
                  strain={strain}
                  trackingLabel="view strain page"
                  trackingCategory="strain_card"
                  accessoryTray={
                    <StrainCardAccessoryTray
                      strain={strain}
                      hasMenuItems={hasMenuItems}
                      trackingCategory="strain_card"
                      trackingAction="click"
                      trackingLabel={
                        hasMenuItems
                          ? "shop menus button"
                          : "learn more button - view strain page"
                      }
                    />
                  }
                />
              );
            })}
      </div>

      <SearchViewMoreButton category="strain" />

      <h3 className="mt-section mb-md">Shop by strain type</h3>
      <PhenotypeCarousel asLink />
    </>
  );
};

export default StrainResults;
